import {
  ChatbotMessage,
  ReferenceCard,
  ReferenceCardResponse,
} from '../models/chatbot/types';

/**
 * Query key factory for chat messages
 */
export const chatMessagesQueryKey = (programId: string, threadId?: string) => [
  'chat-messages',
  programId,
  threadId || 'default',
];

/**
 * Transform serialized card { type, attributes } to flat ReferenceCard.
 * API responses now return cards in serialized format, but components expect flat cards.
 */
export const transformSerializedCard = (
  card: ReferenceCardResponse | ReferenceCard | undefined
): ReferenceCard | undefined => {
  if (!card) return undefined;
  // Check if it's already a flat card (has action directly) or serialized (has attributes)
  if ('attributes' in card) {
    return { ...card.attributes, type: card.type } as ReferenceCard;
  }
  return card as ReferenceCard;
};

/**
 * Transform message references to use flat card format.
 * Handles both serialized cards from API and already-flat cards from streaming.
 */
export const transformMessageReferences = (
  message: ChatbotMessage
): ChatbotMessage => {
  if (!message.references?.length) return message;
  return {
    ...message,
    references: message.references.map((ref) => ({
      ...ref,
      card: transformSerializedCard(
        ref.card as ReferenceCardResponse | ReferenceCard | undefined
      ),
    })),
  };
};
